var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class ModuleMedia extends Component {
    constructor(isDebugEnabled = false) {
        super('ModuleMedia', isDebugEnabled);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-play').on('click', (event, button) => {
                event.preventDefault();
                const parent = button.parents('.media-audio');
                const audio = parent.find('audio');
                audio.get(0).play();
                button.addClass('d-none');
                parent.find('.btn-pause').removeClass('d-none');
            });
            $('.btn-pause').on('click', (event, button) => {
                event.preventDefault();
                const audio = button.parents('.media-audio').find('audio');
                audio.get(0).pause();
                button.addClass('d-none');
                button.parents('.media-audio').find('.btn-play').removeClass('d-none');
            });
            this.success();
        });
    }
}
